import { jsx as _jsx } from "react/jsx-runtime";
// Components
import { Text } from '@kubit/web-ui-product-components';
// Configurations
import { paragraphConfigurationPropsConversion } from './configurations/paragraph.configuration';
//Constants
import { ParagraphVariantsType, ParagraphSizesType, ParagraphWeightType, } from '../../designSystem/reloaded/commons/components/variants';
//Hooks
import { ParagraphStylesHook } from './hooks/paragraph-styles.hook';
const ParagraphComponent = ({ variant = ParagraphVariantsType.DEFAULT, size = ParagraphSizesType.MEDIUM, weight = ParagraphWeightType.REGULAR, ...props }) => {
    const { styles } = ParagraphStylesHook({ variant, size, weight });
    return _jsx(Text, { ...paragraphConfigurationPropsConversion({ ...props, styles }) });
};
export { ParagraphComponent };
//# sourceMappingURL=paragraph.component.js.map